import { FR } from './france';

export const MF = FR;
